import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
const HERO_IMG = 'https://cdn.magicpatterns.com/uploads/oYoCMLLFnfNfZMicXNYmVD/portada_landing_nueva.jpg';
// Inject resource hints to speed up font + image CDN handshakes on mobile.
function addHead(rel: string, href: string, opts: Partial<HTMLLinkElement> = {}) {
  const link = document.createElement('link');
  link.rel = rel;
  link.href = href;
  Object.assign(link, opts);
  document.head.appendChild(link);
}
// Preconnect to critical origins
addHead('preconnect', 'https://fonts.googleapis.com');
addHead('preconnect', 'https://fonts.gstatic.com', {
  crossOrigin: 'anonymous'
} as any);
addHead('preconnect', 'https://cdn.magicpatterns.com', {
  crossOrigin: 'anonymous'
} as any);
addHead('dns-prefetch', 'https://connect.facebook.net');
// Preload the hero image so it starts downloading in parallel with the JS bundle.
// This is the biggest mobile LCP win because the LCP element is the hero image.
const preloadLink = document.createElement('link');
preloadLink.rel = 'preload';
preloadLink.as = 'image';
preloadLink.href = HERO_IMG;
(preloadLink as any).fetchPriority = 'high';
document.head.appendChild(preloadLink);
render(<App data-id="element-545" />, document.getElementById('root'));
// Defer Meta Pixel until the page is idle so its script (~70KB) doesn't compete
// with critical first-paint resources on slow mobile networks.
function loadPixelDeferred() {
  initMetaPixel();
  trackPageView();
}
function scheduleDeferred(fn: () => void) {
  if (typeof window === 'undefined') return;
  const ric = (window as any).requestIdleCallback as ((cb: () => void, opts?: {
    timeout: number;
  }) => number) | undefined;
  if (ric) {
    ric(fn, {
      timeout: 4000
    });
  } else {
    setTimeout(fn, 2500);
  }
}
if (document.readyState === 'complete') {
  scheduleDeferred(loadPixelDeferred);
} else {
  window.addEventListener('load', () => scheduleDeferred(loadPixelDeferred), {
    once: true
  });
}